/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Atelier_StyleInputs */

const en_scene_atelier_style = /** @type {(inputs: Scene_Atelier_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style`)
};

/**
* | output |
* | --- |
* | "Style" |
*
* @param {Scene_Atelier_StyleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_atelier_style = /** @type {((inputs?: Scene_Atelier_StyleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Atelier_StyleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_atelier_style(inputs)
});